import {generateAsyncActionCreators} from '../core/reduxUtils';

const getSeoInfoActionCreators = generateAsyncActionCreators(
  'GET_SEO_INFO',
  (params) => ({
    params,
  })
);

const getGenericSeoInfoActionCreators = generateAsyncActionCreators(
  'GET_GENERIC_SEO_INFO',
  (body) => ({
    body,
  })
);

const getDeeplinkActionCreators = generateAsyncActionCreators(
  'GET_DEEP_LINK',
  (params) => ({
    params,
  })
);

const actionCreators = {
  setSeoInfo(response){
    return {
      type: 'SET_SEO_INFO',
      payload: {
        response,
      },
    }
  },
  updateSeoInfo(response){
    return {
      type: 'UPDATE_SEO_INFO',
      payload: {
        response,
      },
    }
  },
  setNextSeoInfo(response){
    return {
      type: 'SET_NEXT_SEO_INFO',
      payload: {
        response,
      },
    }
  },
  getSeoInfo:{
    ...getSeoInfoActionCreators,
  },
  getGenericSeoInfo:{
    ...getGenericSeoInfoActionCreators,
  },
  getDeepLink:{
    ...getDeeplinkActionCreators,
  },

};


export {
  actionCreators,
  getSeoInfoActionCreators,
  getGenericSeoInfoActionCreators,
  getDeeplinkActionCreators,
};
